import { useCallback } from 'react'

type UseHideSplashScreenResult = {
  hideSplashScreen: () => void
}

export const useHideSplashScreen = (): UseHideSplashScreenResult => {
  const hideSplashScreen = useCallback(() => {
    const splashScreen = document.querySelector<HTMLElement>('#splash-screen')

    if (splashScreen) {
      splashScreen.style.opacity = '0'
      setTimeout(() => splashScreen.remove(), 300)
    }
  }, [])
  return { hideSplashScreen }
}
